import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ClientCustomerType } from '@econtractor/types';
import SpinnerBlock from 'components/others/SpinnerBlock';
import type { NewObjectType } from 'modules/lead';
import type { NewSaleType } from 'modules/objects';
import { type ClientCustomerActionClient } from '../ClientCustomerAction';
import ClientCustomersTableBody from './ClientCustomersTableBody';

interface ClientCustomersTableProps {
    rows: ClientCustomerType[];
    showSpinner?: boolean;
    onEdit: (row: ClientCustomerType) => void;
    onDelete: (row: ClientCustomerType) => void;
    onCreateSale?: (sale: NewSaleType) => void;
    onCreateObject?: (object: NewObjectType) => void;
    client?: ClientCustomerActionClient;
}

const ClientCustomersTable = ({
    rows,
    showSpinner = false,
    onEdit,
    onDelete,
    onCreateSale,
    onCreateObject,
    client,
}: ClientCustomersTableProps) => {
    const { t } = useTranslation(['Clients']);

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur={true} show={showSpinner} />
            <div className="crm-table-wrap">
                <Table className="ClientCustomersTable table-hover mb-0">
                    <thead>
                        <tr className="bg-light">
                            <td className="head-name">{t('subjects.fields.fullName')}</td>
                            <td className="head-article">{t('subjects.fields.edrpouOrIpn')}</td>
                            <td className="head-status">{t('subjects.fields.personType')}</td>
                            <td className="head-action">{t('subjects.fields.action')}</td>
                        </tr>
                    </thead>
                    <ClientCustomersTableBody
                        rows={rows}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        onCreateSale={onCreateSale}
                        onCreateObject={onCreateObject}
                        client={client}
                    />
                </Table>
            </div>
        </div>
    );
};

export default ClientCustomersTable;
